
export const apiShareSim = "1.0/affiliate/create"
export const apiDetailSim = (id) => `1.0/sell/sim/${id}/detail`
export const apiListAffiliate = `1.0/affiliate/list`
export const apiBuySimAffiliate = id => `1.0/wsm/buy/sim/${id}/order`
